<template>
  <v-layout wrap style="height: 30px">
    <v-navigation-drawer v-model="enableFilters" persistent fixed width="600">
      <v-form>
        <v-container>
          <v-layout>
            <v-flex xs12 md4>
              <v-menu
                v-model="menuStartAt"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="computedStartAtFormatted"
                    label="Data Inicial"
                    persistent-hint
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="startAt"
                  no-title
                  @input="menuStartAt = false"
                  class="“no-pointer-events”"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs12 md4>
              <v-menu
                v-model="menuEndAt"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="computedEndAtFormatted"
                    label="Data Final"
                    persistent-hint
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="endAt"
                  no-title
                  @input="menuEndAt = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
          <div>
            <v-subheader>Outros Filtros</v-subheader>
          </div>
          <v-layout>
            <v-flex xs12 sm6 d-flex>
              <v-select :items="partners" label="Tipo de Parceiro" v-model="with_partner"
                        item-text="title" item-value="value"
                        return-object prepend-icon="work_outline" />
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12 md4>
              <v-text-field
                v-model="id"
                label="ID"
                required
                prepend-icon="fingerprint"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 md4>
              <v-text-field
                v-model="name"
                label="Nome"
                prepend-icon="business"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex xs12 md4>
              <v-text-field
                v-model="cpf"
                label="CPF"
                placeholder="CPF do Proprietário"
                prepend-icon="badge_outline"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field v-model="cnpj" label="CNPJ" required></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex xs12 sm6 d-flex>
              <v-select
                :items="accountTypes"
                label="Tipo de Conta"
                v-model="account_type"
                item-text="title"
                item-value="business"
                return-object
                prepend-icon="filter_alt"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12 sm6 d-flex>
              <v-select
                :items="ordinations"
                label="Ordenação"
                v-model="ordination"
                item-text="title"
                item-value="business"
                return-object prepend-icon="swap_vert"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-btn @click="getResources">Enviar</v-btn>
          <v-btn @click="reset">Limpar</v-btn>
          <v-btn @click="desableFilters">Fechar</v-btn>
        </v-container>
      </v-form>
    </v-navigation-drawer>
  </v-layout>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import * as business from "@/helpers/business";

export default {
  created() {
    this.$store.dispatch("account/getAccount");
    this.$store.dispatch("partner/filterParams");
  },
  components: {
    
  },
  data: (vm) => ({
    id: null,
    cpf: null,
    cnpj: null,
    name: null,
    account_type: null,
    startAt: null,
    endAt: null,
    page: 1,
    limit: 10,
    startAtFormatted: null,
    endAtFormatted: null,
    menuStartAt: false,
    menuEndAt: false,
    enableFilters: false,
    with_partner: null,
    accountTypes: [
      { title: "Todos", business: "" },
      { title: "Pessoal", business: business.PARTNER_ACCOUNT_PERSONAL },
      { title: "Empresarial", business: business.PARTNER_ACCOUNT_BUSINESS },
    ],
    ordinations: [
      { title: 'Mais antigos', business: business.PARTNER_LOWER_ORDER },
      { title: 'Mais recentes', business: business.PARTNER_MOST_RECENT_ORDER },
    ],
    partners: [
      { title: "Todos", value: "" },
      { title: "Master", value: "master" },
      { title: "Executivo", value: "executive" }
    ],
  }),
  computed: {
    accountType: {
      get() {
        return this.accountType;
      },
      set(newAccountType) {
        this.$store.dispatch("partners/setAccountType", newAccountType);
        this.accountType;
      },
    },
    partner: {
      get() {
        return this.partner;
      },
      set(newPartner) {
        this.$store.dispatch("partners/setPartner", newPartner);
        this.partner;
      },
    },
    ordination: {
      get() {
        return this.ordination;
      },
      set(value) {
        this.$store.dispatch("partners/setOrdination", value);
        this.ordination;
      },
    },

    ...mapGetters({
      filters: "partners/filter",
      name: "partners/filtersName",
      showFilters: "partners/showFilters",
      isLoading: "partners/loadingData",
      partner: "partners/filtersPartner",
      ordination: "partners/filtersOrdination",
      accountType: "partners/filtersAccountType",
      partnerLevel: "account/partner",
    }),
    computedStartAtFormatted() {
      return this.formatDate(this.startAt);
    },
    computedEndAtFormatted() {
      return this.formatDate(this.endAt);
    },
  },
  watch: {
    showFilters(newValue) {
      this.showFilters = newValue;
      this.enableFilters = newValue;
    },
    startAt(val) {
      this.startAtFormatted = this.formatDate(this.startAt);
      this.$store.state.partners.filterParams.filterrific.with_created_at_between.start_at = this.startAtFormatted;
    },
    endAt(val) {
      this.endAtFormatted = this.formatDate(this.endAt);
      this.$store.state.partners.filterParams.filterrific.with_created_at_between.end_at = this.endAtFormatted;
    }
  },
  methods: {
    getResources() {
      this.params = {
        page: this.page,
        limit: this.limit,
        filterrific: {
          with_created_at_between: {
            start_at: this.startAt,
            end_at: this.endAt,
          },
          with_id: this.id,
          with_name: this.name,
          with_cnpj: this.cnpj,
          with_cpf: this.cpf,
          with_account_type: this.account_type,
          with_partner: this.with_partner,
          sorted_by: this.ordination,
        },
      };
      this.$store.state.partners.filterParams = this.params;
      this.$store.dispatch("partners/load", this.params);
      this.desableFilters();
    },
    desableFilters() {
      this.$store.dispatch("partners/showFilters", false);
      this.enableFilters = false;
    },
    reset() {
      this.startAt = null;
      this.endAt = null;
      this.$store.dispatch("partners/resetFilters");
      this.$store.state.partners.filterParams.filterrific.with_created_at_between = {
        start_at: null,
        end_at: null,
      };
      this.$store.dispatch("partners/load", this.$store.state.partners.filterParams);
      this.$store.dispatch("partners/showFilters", false);
      this.name = null
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    }
  },
};
</script>
